import * as R from 'ramda';
import { categoryDisplay } from '../dimension-utils';
import { getFormatedObservation } from '../observation-formater';

const getDatapoints = (
  keys,
  observations,
  dimensions,
  dimensionsWithValuesIndexedById,
  sortDirection,
  display,
  formaterAttrs,
) => {
  const [categoryKey, valueKey] = keys;
  const sortFunc = dp => dp[valueKey] * sortDirection;

  return R.pipe(
    R.keys,
    R.map(observationKey => {
      const observationValue = R.prop(observationKey, observations);
      const value = R.head(observationValue);
      const splitKey = R.split(':', observationKey);
      const category = categoryDisplay(
        splitKey,
        dimensions,
        dimensionsWithValuesIndexedById,
        null,
        display,
      );
      const categoryIds = categoryDisplay(
        splitKey,
        dimensions,
        dimensionsWithValuesIndexedById,
        null,
        'code',
      );
      const formatedValue = getFormatedObservation(observationValue, formaterAttrs);

      let key = categoryIds;
      if (R.isNil(key) || R.isEmpty(key)) {
        key = 'uniq-dp';
      }

      return { value, category, [valueKey]: value, [categoryKey]: category, key, formatedValue };
    }),
    R.sortBy(sortFunc),
  )(observations);
};

const series = (
  keys,
  observations,
  dimensions,
  dimensionsWithValuesIndexedById,
  sortDirection,
  display,
  formaterAttrs,
) => {
  return [
    {
      datapoints: getDatapoints(
        keys,
        observations,
        dimensions,
        dimensionsWithValuesIndexedById,
        sortDirection,
        display,
        formaterAttrs,
      ),
    },
  ];
};

export default (
  chartType,
  { observations, dimensions },
  dimensionsWithValuesIndexedById,
  display,
  formaterAttrs,
) => {
  switch (chartType) {
    case 'BarChart':
      return series(
        ['x', 'y'],
        observations,
        dimensions,
        dimensionsWithValuesIndexedById,
        1,
        display,
        formaterAttrs,
      );
    case 'RowChart':
      return series(
        ['y', 'x'],
        observations,
        dimensions,
        dimensionsWithValuesIndexedById,
        -1,
        display,
        formaterAttrs,
      );
    default:
      return [];
  }
};
